import { useEffect } from "react";
import "./AddToCartSuccess.css";
import { Check, X } from "lucide-react";

const AddToCartSuccess = ({ text = "", tick = true, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onClose) onClose();
    }, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const handleClick = () => {
    if (onClose) onClose();
  };

  return (
    <div className="addtocartsuccess_v2" onClick={handleClick}>
      <div className="addtocartsuccess-content_v2">
        <div className="atcsuccess-tick_v2">
          {tick ? <Check size={32} /> : <X size={32} />}
        </div>

        <div className="atcsuccess-title_v2">
          {tick ? "Success!" : "Failed!"}
        </div>
        <div className="atcsuccess-text_v2">{text}</div>
      </div>
    </div>
  );
};

export default AddToCartSuccess;
